import { styled } from '@mui/material/styles';

const StyledChatAgentStep = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 2.5rem;
  justify-content: center;
  align-items: flex-start;
`;

export default StyledChatAgentStep;
